import React from "react";
import { IAccordionItem } from "../../types/IAccordionItem";
import { IContentfulBackgroundColour } from "../../types/IContentfulBackgroundColour";
import { AccordionItem } from "./AccordionItem";

export interface IProps {
  backgroundColour?: IContentfulBackgroundColour;
  accordion: IAccordionItem[];
}

const Accordion: React.FC<IProps> = ({ accordion, backgroundColour = "lime-green" }) => (
  <>
    {accordion
        && accordion.map((item, index) => (
          <AccordionItem
            key={index}
            index={index}
            backgroundColour={backgroundColour}
            item={item}
          />
        ))}
  </>
);

export { Accordion };
